import { AssetsTable } from './components/AssetsTable';

export function AssetsPage() {
  return (
    <main className="page-gutter min-w-0 flex-1 overflow-x-hidden py-4 sm:py-6 lg:py-8">
      <AssetsTable />
    </main>
  );
}
